import React from 'react';
import clsx from 'clsx';

import { InventorySchemaActions } from '@atom/types/actions';
import iconUtilities from '@atom/utilities/iconUtilities';

import SchemaElementListRow from './SchemaElementListRow';

import classes from './elements.module.css';

const RIGHT_ARROW = 'right-arrow';
const DOWN_ARROW = 'down-arrow';
const VISIBLE = 'inherit';
const HIDDEN = 'none';

interface ElementGroup {
  name: string;
  elements: any[];
}

interface Props {
  elementGroup: ElementGroup;
  selectedItems: Set<any>;
  schemaQuantities: object;
  onClick: (id?: string) => any;
  onChange: () => any;
  elementGroupIndex?: number;
  inventorySchemaActions: InventorySchemaActions;
  loadingSchemaTreeNode: boolean;
}

class SchemaElementGroupSection extends React.Component<Props> {
  state = {
    icon: iconUtilities.leftIcon(RIGHT_ARROW),
    expanded: HIDDEN,
  };

  toggleSection = () => {
    const { expanded } = this.state;

    if (expanded === HIDDEN) {
      this.setState({
        icon: iconUtilities.leftIcon(DOWN_ARROW),
        expanded: VISIBLE,
      });
    } else {
      this.setState({
        icon: iconUtilities.leftIcon(RIGHT_ARROW),
        expanded: HIDDEN,
      });
    }
  };

  render() {
    const {
      elementGroup,
      selectedItems,
      onClick,
      schemaQuantities,
      onChange,
      elementGroupIndex,
      inventorySchemaActions,
      loadingSchemaTreeNode,
    } = this.props;
    const { icon, expanded } = this.state;

    return (
      <div>
        <div
          className={clsx(classes.groupContainer, classes.modal)}
          onClick={this.toggleSection}
        >
          <div className={classes.groupIcon}>{icon}</div>
          <div className={classes.groupLabel}>{elementGroup.name}</div>
        </div>
        <div
          className={classes.elementListContainer}
          style={{ display: expanded }}
        >
          {elementGroup.elements.map((element, elementIndex) => (
            <SchemaElementListRow
              isChecked={selectedItems.has(element.id)}
              inventorySchemaActions={inventorySchemaActions}
              loading={loadingSchemaTreeNode}
              onChange={onChange}
              key={element.id}
              element={element}
              value={schemaQuantities[element.id]}
              selectedItems={selectedItems}
              schemaQuantities={schemaQuantities}
              onClick={onClick}
              elementPath={[
                'elementGroups',
                elementGroupIndex,
                'elements',
                elementIndex,
              ]}
            />
          ))}
        </div>
      </div>
    );
  }
}

export default SchemaElementGroupSection;
